module.exports = __webpack_public_path__ + "static/media/image-13.6734c6b5.jpg";